<template>
    <div v-if="isShow" class="container" >
        <div class="responsive-hero-header hero p-5 text-center bg-image rounded-bottom-1"
             :style="{ backgroundImage: 'url(' + getImage(themes.hero) + ')' }"
        >
            <div class="d-flex justify-content-center align-items-center h-100">
                <div class="text-white">
                    <h1 class="mb-3 hero_title"> {{ $t('home.hero_name') }}</h1>
                    <span>{{ getFullKhmerDate()}}</span>
                </div>
            </div>
        </div>
    </div>


</template>

<script setup>

import Menu from "../Share/Menu";
import {Link, usePage} from '@inertiajs/vue3';
import { computed } from "vue";


import {useI18n} from "vue-i18n";
const themes = computed(() => usePage().props.themes);
console.log(themes.value);
const props = defineProps(
    { isShow: Boolean }
);
const { locale, t } = useI18n();

</script>
<style scoped>
.hero {
  height: 400px;
  max-height: 100vh;
  width: 100%;
  background-size: cover;
  background-position: top;
}
@media (max-width: 768px) {
    .responsive-hero-header {
        height: auto !important;
    }
    h1{
        font-size: 20px;
        padding-bottom: 50px !important;
    }
    .responsive-hero-header .hero_title{
        padding: 0px !important;
    }
}
</style>
